import React, { useEffect } from "react";
import "./ParentConnect.css";

// ✅ Correct path (src/pages -> src/assets)
import parentConnectImg from "../assets/parents-connect.JPG";
import darpanAppImg from "../assets/darpan-app.jpeg";

const ParentConnect = () => {
  useEffect(() => {
    const elements = document.querySelectorAll("[data-animate]");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("pc-in-view");
        });
      },
      { threshold: 0.15 }
    );

    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section className="parent-connect" id="parent-connect">
      <div className="pc-inner">
        {/* LEFT COLUMN: Single Container wrapping Text & Image */}
        <div className="pc-left-col">
          <div
            className="pc-header pc-left-slot pc-left-slot--text"
            data-animate="fade-up"
          >
            <span className="pc-pill">Parent Connect</span>
            <h2 className="pc-title">
              Strong partnerships <span>between home and school</span>
            </h2>
            <p className="pc-subtitle">
              At Vivek Vardhini Creative Minds School, parents are not just
              informed&mdash;they are truly connected to their child&apos;s day,
              learning progress and overall growth.
            </p>
          </div>

          <div
            className="pc-left-slot pc-left-slot--image"
            data-animate="fade-up"
            data-delay="1"
          >
            <img
              src={parentConnectImg}
              alt="Parent Connect"
              className="pc-side-image"
              loading="lazy"
            />
          </div>
        </div>

        {/* Timeline line (behind cards) */}
        <div className="pc-timeline" aria-hidden="true" />

        {/* RIGHT: Cards */}
        {/* 1. DARPAN APP */}
        <article className="pc-card pc-card--1" data-animate="slide-up">
          <div className="pc-timeline-dot" />
          <div className="pc-card-header">
            <div className="pc-icon-wrap">
              <span className="pc-icon">📱</span>
            </div>
            <div>
              <h3>DARPAN App</h3>
              <p className="pc-tagline">Live connection. Real-time trust.</p>
            </div>
          </div>

          <p className="pc-body">
            At Vivek Vardhini Creative Minds School, we believe in building a
            strong and transparent connection with our parents. Through our
            exclusive <strong>DARPAN App</strong>, parents receive{" "}
            <strong>LIVE CCTV access</strong> to monitor their child in real
            time, ensuring complete peace of mind and trust.
          </p>

          <p className="pc-body">
            Beyond live monitoring, the app provides a{" "}
            <strong>comprehensive suite of features</strong> including instant
            test results, school notices, updates on extracurricular activities,
            daily attendance, and essential academic information. This seamless
            digital platform keeps parents{" "}
            <strong>informed, involved, and connected</strong> with their
            child&apos;s learning journey like never before.
          </p>

          <ul className="pc-feature-list">
            <li>LIVE CCTV classroom view</li>
            <li>Instant test results & school notices</li>
            <li>Attendance & academic updates at a glance</li>
            <li>Student Progress Portfolio</li>
          </ul>
          <img
            src={darpanAppImg}
            alt="Parent Connect"
            className="pc-side-image"
            loading="lazy"
          />
        </article>

        {/* 2. LIVE BUS TRACKING */}
        <article
          className="pc-card pc-card--2"
          data-animate="slide-up"
          data-delay="1"
        >
          <div className="pc-timeline-dot" />
          <div className="pc-card-header">
            <div className="pc-icon-wrap">
              <span className="pc-icon">🚌</span>
            </div>
            <div>
              <h3>Live Bus Tracking</h3>
              <p className="pc-tagline">Safe journeys. Calm parents.</p>
            </div>
          </div>

          <p className="pc-body">
            We ensure complete transparency and peace of mind for parents
            through our <strong>Live Bus Tracking System</strong>. This smart
            feature allows parents to monitor their child&apos;s journey in
            real time&mdash;from home to school and back.
          </p>

          <p className="pc-body">
            Every ride is supported with{" "}
            <strong>location accuracy and timely updates</strong>, so parents
            always know where the bus is and when their child will arrive,
            making daily commutes smoother, safer and stress-free.
          </p>

          <ul className="pc-feature-list">
            <li>Real-time bus location on map</li>
            <li>Alerts for arrival & departure</li>
            <li>Added safety and accountability</li>
          </ul>
        </article>

        {/* 3. FEEDBACK & SUPPORT SYSTEM */}
        <article
          className="pc-card pc-card--3"
          data-animate="slide-up"
          data-delay="2"
        >
          <div className="pc-timeline-dot" />
          <div className="pc-card-header">
            <div className="pc-icon-wrap">
              <span className="pc-icon">🤝</span>
            </div>
            <div>
              <h3>Feedback &amp; Support System</h3>
              <p className="pc-tagline">
                Open conversations. Continuous support.
              </p>
            </div>
          </div>

          <p className="pc-body">
            Our <strong>Feedback and Support System</strong> is strengthened
            through regular <strong>Parent–Teacher Meetings</strong>, where
            parents can openly discuss their child&apos;s academic progress,
            behaviour and overall development with teachers.
          </p>

          <p className="pc-body">
            Parents also receive consistent updates about their child&apos;s{" "}
            <strong>attendance, performance and learning</strong> milestones
            through our digital platforms, ensuring complete transparency and
            continuous communication.
          </p>

          <p className="pc-body">
            This dual approach helps parents stay{" "}
            <strong>informed, involved and connected</strong> with their
            child&apos;s learning journey at all times.
          </p>

          <ul className="pc-feature-list">
            <li>Regular PTMs with meaningful discussion</li>
            <li>Digital progress updates and reminders</li>
            <li>Easy channels for feedback & support</li>
          </ul>
        </article>
      </div>
    </section>
  );
};

export default ParentConnect;